import $ from 'jquery';

const pageContent = () => {
  const accordions = $('.js-accordion_item');
  $(accordions.last()).css('borderBottom', 'none')
  $.each(accordions, (index, item) => {
    $(item).click(() => {
      $(item).toggleClass('page-content-accordion__item--active');

      const panel = $(item).next('.page-content-accordion__content');
      $(item).find('.icon-container .page-content-accordion__icon').toggleClass('page-content-accordion__icon--active');

      if (panel.css('maxHeight') !== '0px' && panel.css('maxHeight') !== null) {
        panel.css('maxHeight', '');
      } else {
        panel.css('maxHeight', `${panel.prop('scrollHeight')}px`);
      }
    });
  });
};


export default () => {
  pageContent();
};

